import React from "react";
import { regions, regionOrder } from "../data/pricing";

// Segmented control to switch pricing region (IN / HK / ROW).
export const RegionSwitcher = ({ region, setRegion, className = "" }) => (
  <div
    className={`inline-flex flex-wrap justify-center gap-1 p-1 bg-white rounded-full border border-accent/30 shadow-soft ${className}`}
    role="group"
    aria-label="Choose your region"
  >
    {regionOrder.map((code) => {
      const r = regions[code];
      const active = region === code;
      return (
        <button
          key={code}
          type="button"
          onClick={() => setRegion(code)}
          aria-pressed={active}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
            active
              ? "bg-primary text-white shadow-soft"
              : "text-charcoal/70 hover:text-primary"
          }`}
        >
          <span className="mr-1">{r.flag}</span>
          {r.label}
        </button>
      );
    })}
  </div>
);

export default RegionSwitcher;
